// Canonical CRM reference lists — single source of truth for Create + Edit forms.
// Backend mirrors CUSTOMER_TYPES in models.py (validated on create + update).

export const CUSTOMER_TYPES = [
  { value: "new", label: "New" },
  { value: "regular", label: "Regular" },
  { value: "vip", label: "VIP" },
];

export const CUSTOMER_SOURCES = ["walk_in", "website", "instagram", "referral", "google", "facebook"]
  .map((s) => ({ value: s, label: s.replace("_", " ") }));
